import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=5623d576&scoped=true&"
import script from "./ScheduleItem.vue?vue&type=script&lang=ts&"
export * from "./ScheduleItem.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=5623d576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623d576",
  null
  
)

export default component.exports